import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function ElectricalMaintenancePage() {
  const serviceData = {
    title: 'Electrical Maintenance',
    subtitle: 'Preventive Care for Your Electrical System',
    description: 'Regular electrical maintenance prevents costly breakdowns and ensures your system operates safely and efficiently. Our comprehensive maintenance services identify potential issues before they become problems, extending the life of your electrical infrastructure.',
    heroImage: 'https://public.readdy.ai/ai/img_res/95c8f9e0e90ef6263e115dbf362a0bd2.jpg',
    features: [
      {
        icon: 'ri-calendar-check-line',
        title: 'Scheduled Service',
        description: 'Regular maintenance programs available'
      },
      {
        icon: 'ri-search-eye-line',
        title: 'Thorough Inspections',
        description: 'Comprehensive electrical system checks'
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Detailed Reports',
        description: 'Complete documentation of findings'
      },
      {
        icon: 'ri-tools-line',
        title: 'Preventive Repairs',
        description: 'Fix small issues before they escalate'
      }
    ],
    benefits: [
      'Comprehensive electrical inspections',
      'Safety switch testing',
      'Smoke alarm testing',
      'Switchboard maintenance',
      'Thermal imaging scans',
      'Wiring condition assessment',
      'Appliance safety checks',
      'Detailed maintenance reports'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Schedule Service',
        description: 'Book your maintenance appointment'
      },
      {
        number: '02',
        title: 'Comprehensive Inspection',
        description: 'Thorough examination of all electrical components'
      },
      {
        number: '03',
        title: 'Testing & Analysis',
        description: 'Perform safety tests and identify issues'
      },
      {
        number: '04',
        title: 'Report & Recommendations',
        description: 'Receive detailed findings and maintenance advice'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}